import { ReactNode } from 'react'

import cx from 'classnames'

import { Alert as AlertIcon } from './Icons'
import { ExitIcon } from './Icons/ExitIcon'

import styles from './Alert.module.scss'

interface AlertProps {
  type: 'Error'
  dismiss?: () => void
  title: string
  body: string
  extraInfo?: string
  'data-cy'?: string
  className?: string | string[]
}

interface AlertWithSubtitleProps {
  type: 'Error'
  dismiss?: () => void
  title: string
  subtitle: string | ReactNode
  body: string | ReactNode
  'data-cy'?: string
  className?: string | string[]
}

export const Alert: React.FC<AlertProps> = ({
  type,
  dismiss,
  title,
  body,
  extraInfo,
  'data-cy': dataCy,
  className: additionalClasses,
}) => {
  return (
    <div className={cx(styles.Alert, styles[type], additionalClasses)} data-cy={dataCy}>
      {dismiss && (
        <button onClick={dismiss} className={styles.ExitIcon}>
          <ExitIcon />
        </button>
      )}
      <h1>{title}</h1>
      <p>{body}</p>
      <p>{extraInfo}</p>
    </div>
  )
}

export const AlertWithSubtitle: React.FC<AlertWithSubtitleProps> = ({
  type,
  dismiss,
  title,
  subtitle,
  body,
  'data-cy': dataCy,
  className: additionalClasses,
}) => {
  return (
    <div className={cx(styles.Alert, styles.AlertWithSubtitle, styles[type], additionalClasses)} data-cy={dataCy}>
      {dismiss && (
        <button onClick={dismiss} className={styles.ExitIcon}>
          <ExitIcon />
        </button>
      )}
      <AlertIcon type="error" />
      <h2>{title}</h2>
      <h1>{subtitle}</h1>
      <p>{body}</p>
    </div>
  )
}
